<template>
    <v-content>
        <v-container>
            <v-card>
                <v-card-title>
                    <v-icon>supervised_user_circle</v-icon> Areas:
                    <v-spacer/>
                    <v-text-field
                            v-model="search"
                            append-icon="search"
                            label="Buscar"
                            single-line
                            hide-details
                    />
                    <v-btn @click="openModal(true)" class="mx-2 py-0" color="primary"><v-icon>add_circle</v-icon></v-btn>
                </v-card-title>
                <v-data-table
                        :headers="headers"
                        :items="areas"
                        :items-per-page="5"
                        :search="search"
                        class="elevation-1"
                        ref="table"
                >
                    <template v-slot:item.actions="{ item }">
                        <v-icon
                                small
                                class="mr-2"
                                @click="editItem(item)"
                        >
                            edit
                        </v-icon>
                        <v-icon
                                small
                                @click="deleteItem(item)"
                        >
                            delete
                        </v-icon>
                    </template>
                </v-data-table>
            </v-card>

            <v-dialog
                    v-model="dialog"
                    width="600"

            >
                <ValidationObserver ref="obs" v-slot="{ handleSubmit }">
                    <v-card>
                        <v-card-title class="headline text-center">{{edit ? 'Editar': 'Crear'}} Area</v-card-title>
                        <v-form
                                @submit.prevent="handleSubmit(formSubmit)"
                                ref="form"
                                lazy-validation
                                class="container"
                        >
                            <v-row no-gutters>
                                <v-col cols="12" md="6">
                                   <ValidationProvider rules="required" name="type" v-slot="{ errors, valid }">
                                       <v-select
                                               name="type"
                                               v-model="area.type"
                                               label="Tipo:"
                                               placeholder="Ingresa el tipo de area"
                                               :error-messages="errors"
                                               :success="valid"
                                               :items="types"
                                       />

                                   </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <ValidationProvider rules="required" name="name" v-slot="{ errors, valid }">
                                        <v-text-field
                                                v-model="area.name"
                                                name="name"
                                                label="Nombre:"
                                                placeholder="Ingresa el nombre"
                                                :error-messages="errors"
                                                :success="valid"
                                        />
                                    </ValidationProvider>

                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="12" md="6">
                                    <ValidationProvider rules="email" name="email" v-slot="{ errors, valid }">
                                        <v-text-field
                                                v-model="area.email"
                                                name="email"
                                                label="Email:"
                                                placeholder="Ingresa tu correo electrónico"
                                                :error-messages="errors"
                                                :success="valid"
                                        />
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <ValidationProvider rules="numeric" name="phone" v-slot="{ errors, valid }">
                                        <v-text-field
                                                v-model="area.phone"
                                                name="phone"
                                                label="Telefono:"
                                                placeholder="Ingresa el telefono"
                                                :error-messages="errors"
                                                :success="valid"
                                                type="number"
                                        />
                                    </ValidationProvider>
                                </v-col>
                            </v-row>

                            <v-row no-gutters>
                                <v-col cols="12" >
                                    <ValidationProvider rules="required" name="phone" v-slot="{ errors, valid }">
                                        <v-textarea
                                                v-model="area.address"
                                                name="address"
                                                label="Dirección"
                                                hint="Ingrese la dirección"
                                                :error-messages="errors"
                                                :success="valid"
                                        />
                                    </ValidationProvider>
                                </v-col>

                            </v-row>
                            <v-card-actions>


                                <v-spacer/>
                                <v-btn type="submit">{{edit ? 'Editar' : 'Guardar'}}</v-btn>


                            </v-card-actions>
                        </v-form>

                    </v-card>
                </ValidationObserver>
            </v-dialog>
            <v-snackbar
                    color="success"
                    v-model="snackbar"
            >
                {{ text }}
                <v-btn
                        color="darken"
                        text
                        @click="snackbar = false"
                >
                    Cerrar
                </v-btn>
            </v-snackbar>
        </v-container>
    </v-content>
</template>

<script>
    import { mapActions , mapState} from 'vuex'
    import {TIPO_AREA} from '../plugins/config'
    import {
        ValidationObserver,
    } from "vee-validate";

    export default {
        name: "Areas",
        components:{
            ValidationObserver
        },
        data(){
            return{
                idArea:null,
                valid:true,
                search:'',
                dialog:'',
                edit:false,
                snackbar:false,
                text:'',
                types:TIPO_AREA,
                area:{
                    type:'',
                    email:'',
                    phone:'',
                    address:'',
                    name:''
                },
                headers: [
                    {
                        text: 'Nombre',
                        align: 'left',
                        sortable: true,
                        value: 'name',
                    },
                    { text: 'Tipo', value: 'type' },
                    { text: 'E-mail', value: 'email' },
                    { text: 'Telefono', value: 'phone' },
                    { text: 'Dirección', value: 'address' },
                    { text: 'Opciones', value: 'actions' },

                ],

            }
        },
        methods:{
            ...mapActions([
                'createArea', 'deleteCollect', 'editCollect'

            ]),

            formSubmit(){
                if (this.edit){
                    this.editArea()
                }else{
                    this.saveArea()
                }
            },
            openModal(value){
                this.dialog = value;
                this.edit = false;
                this.area ={
                    type:'',
                        email:'',
                        phone:'',
                        address:'',
                        name:''
                };
                this.idArea = null
            },
            deleteItem(item){
                this.deleteCollect({id:item.id , collection:'areas'})
            },
            editItem(item){
                this.edit =true;
                this.area.email = item.email;
                this.area.phone = item.phone;
                this.area.address = item.address;
                this.area.name = item.name;

                this.idArea = item.id;
                this.dialog = true
            },
            editArea(){
                this.editCollect({id:this.idArea, data:this.area, collection:'areas' });
                this.dialog = false;
                this.text = 'Se ha actualizado satisfactoriamente';
                this.snackbar = true;
            },
            saveArea(){
                this.createArea(this.area);
                this.dialog = false;
                this.text = 'Se ha creado satisfactoriamente';
                this.snackbar = true;


            }
        },

       computed:{
            ...mapState({
              areas:state => state.area.areas
            })
       }
    }
</script>

<style scoped>

</style>